// extracted by mini-css-extract-plugin
export default {"button":"TicketTransactionsActions_button__blsOE"};